// extracted by mini-css-extract-plugin
export default {"cell":"cell__cell__oQRkm","tagMargin":"tagMargin__cell__IOcIs","ellipsize":"ellipsize__cell__vZ5sf"};